export type EntityPageStatus = 'loading' | 'not-found' | 'ready'

export const getEntityPageStatus = <T>(
  loading: boolean,
  data: T | null | undefined,
): EntityPageStatus => {
  if (loading) {
    return 'loading'
  }
  if (!data) {
    return 'not-found'
  }
  return 'ready'
}
